import api from './api'

/**
 * AI Student Advisor Service
 * Wraps the /ai-advisor API. Methods return the inner `data` payload.
 */
const aiAdvisorService = {
  // ---- student ----

  /** Opt-in, latest report, freshness ("results changed"), daily cap. */
  async getStatus() {
    const res = await api.get('/ai-advisor/status')
    return res.data.data
  },

  /**
   * Return the cached (fresh) report, or generate one.
   * @param {boolean} force - force regeneration ("update report")
   */
  async generate(force = false) {
    const res = await api.post('/ai-advisor/reports', { force })
    return res.data.data
  },

  async getLatest() {
    const res = await api.get('/ai-advisor/reports/latest')
    return res.data.data
  },

  async getHistory() {
    const res = await api.get('/ai-advisor/reports/history')
    return res.data.data
  },

  /** Toggle the per-user opt-in. */
  async setEnabled(enabled) {
    const res = await api.put('/ai-advisor/me', { enabled })
    return res.data.data
  },

  // ---- admin ----

  async adminGetConfig() {
    const res = await api.get('/ai-advisor/admin/config')
    return res.data.data
  },

  async adminUpdateConfig(updates) {
    const res = await api.put('/ai-advisor/admin/config', updates)
    return res.data.data
  },

  async adminGetModels() {
    const res = await api.get('/ai-advisor/admin/models')
    return res.data.data
  },

  async adminGetStats(params = {}) {
    const res = await api.get('/ai-advisor/admin/stats', { params })
    return res.data.data
  },

  async adminRunTest() {
    const res = await api.post('/ai-advisor/admin/test')
    return res.data.data
  }
}

export default aiAdvisorService
